<template>

  <div class="lotti-stats-module">

    <div class="lotti-module-title">WochenSoll KW{{ weekNumber }} {{ year }}</div>

    <div class="lotti-stats-week-picker">
      <el-date-picker
          v-model="date"
          type="week"
          size="small"
          format="KW WW"
          :clearable="false"
          :change="onWeekPickerChange()"
          :picker-options="{firstDayOfWeek: 1}"
          placeholder="Woche wählen">
      </el-date-picker>
    </div>

    <div class="lotti-stats-charts-container">
      
      <bar-chart title="A.m.K." :minutes="chart[0].minutes" :percent-bar1="chart[0].bar1" :percent-bar2="chart[0].bar2"></bar-chart>
      <bar-chart title="Berechenbar" :minutes="chart[1].minutes" :percent-bar1="chart[1].bar1" :percent-bar2="chart[1].bar2"></bar-chart>
      <bar-chart title="Nicht berech." :minutes="chart[2].minutes" :percent-bar1="chart[2].bar1" :percent-bar2="chart[2].bar2"></bar-chart>
      <bar-chart title="KW Überzeit" :minutes="chart[3].minutes" :percent-bar1="chart[3].bar1" :percent-bar2="chart[3].bar2"></bar-chart>
      <bar-chart title="Total Überzeit" :minutes="chart[4].minutes" :percent-bar1="chart[4].bar1" :percent-bar2="chart[4].bar2"></bar-chart>

    </div>

  </div>

</template>

<script>
import auth from '../../auth.js';
import barChart from '../../components/atomics/BarChart'
import datePickerHelper from '../../Helpers/DatePickerHelper';
import {VueInstance} from '../../main';
import Vue from "../../main";

export default {

  props: {
    leadView: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      auth: auth,

      date: Date.now(),
      weekNumber: null,
      year: null,

      chart: [
        {minutes: 0, bar1: 100, bar2: 100},
        {minutes: 0, bar1: 100, bar2: 100},
        {minutes: 0, bar1: 100, bar2: 100},
        {minutes: 0, bar1: 100, bar2: 100},
        {minutes: 0, bar1: 100, bar2: 100},
      ]
    }
  },

  methods: {

    onWeekPickerChange() {

      //calc new weekNumber and year
      let d = new Date(this.date);
      let {weekNumber, year} = datePickerHelper.getWeekNumberAndYear(d);
      year = year.toString().substr(-2);

      //compare new values with old, if there is a change, update them + get new overtime data
      if (this.weekNumber !== weekNumber || this.year !== year) {

        this.weekNumber = weekNumber;
        this.year = year;

        this.getOvertimeForCalendarWeek();
      }
    },

    createObject(data) {
      let max = Math.max(data.WorkedMinutes, data.QuotaMinutes);
      return {
        bar1: data.WorkedMinutes / max * 100,
        bar2: data.QuotaMinutes / max * 100,
        minutes: data.WorkedMinutes - data.QuotaMinutes,
      }
    },

    getOvertimeForCalendarWeek() {
      Vue.http.get(
          'api/v1/therapist/get-overtime',
          {
            params: {
              date: this.date ? datePickerHelper.formatUTCDateUS(this.date) : null,
              lead: this.leadView,
            }
          }
      ).then(response => {

        let d = response.data;

        let newChart = [];
        newChart.push(this.createObject(d.overtimes.Therapy));
        newChart.push(this.createObject(d.overtimes.Billable));
        newChart.push(this.createObject(d.overtimes.NonBillable));
        newChart.push(this.createObject(d.overtimes.Total));
        newChart.push(this.createObject(d.totalOvertime.Total));

        this.chart = newChart;

      }, response => {
        // this.showError(response.data.message);
      })
    }

  },

  beforeMount() {
    //initially get overtime data. but this is not needed,
    //because the el-date-picker thoughts a change event
    //this.getOvertimeForCalendarWeek();
  },

  mounted() {
    //event fired from therapistManagement.vue when this component should update its data
    VueInstance.$on('updatedTherapists', this.getOvertimeForCalendarWeek);
  },

  beforeDestroy() {
    VueInstance.$off('updatedTherapists', this.getOvertimeForCalendarWeek);
  },

  components: {
    barChart: barChart,
  }
}

</script>